import { Tabs } from "antd";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import leftarrow from "../assets/images/u_angle-left-b.svg";
import greyCircle from "../assets/images/ellipse.svg";
import AboutAdvisor from "../components/AdvisorProfileTabs/AboutAdvisor";
import AboutSubscription from "../components/AdvisorProfileTabs/AboutSubscription";
import RecentTrades from "../components/AdvisorProfileTabs/RecentTrades";
import SubscriptionModal from "../components/AdvisorProfileTabs/SubscriptionModal";
import { useGetAdvisorQuery } from "../store/api/advisorsApi";
import { useGetSubscriptionStatusQuery } from "../store/api/tradingApi";

const AdvisorProfile = () => {
  // const { advisor } = useSelector((state) => state.advisors);
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: advisor, isLoading, error } = useGetAdvisorQuery(id);

  const { data: subscriptionStatus } = useGetSubscriptionStatusQuery();

  if (isLoading) {
    return <div>Loading advisor...</div>;
  }

  if (error) {
    return <div>Error loading advisor: {error.message}</div>;
  }

  const subscription = subscriptionStatus?.find(
    (call) =>
      String(call.advisorId).trim().toLowerCase() ===
      String(id).trim().toLowerCase()
  );
  const isExpired = subscription?.expiresAt
    ? new Date(subscription.expiresAt) < new Date()
    : false;

  const isSubscribed = subscription && !isExpired;

  const advisorStats = {
    "Success rate": `%`,
    Accuracy: `%`,
    // ROI: `${advisor?.advisorMetrics?.roi}%`,
    ROI: `%`,
    Experience: `Years`,
  };
  const onChange = (key) => {
    // console.log(key);
  };
  const items = [
    {
      key: "1",
      label: "About Advisor",
      children: (
        <AboutAdvisor
          firstName={advisor?.firstName}
          lastName={advisor?.lastName}
          SEBIRegNo={advisor?.sebiRegistrationNumber}
          content={advisor?.content}
        />
      ),
    },
    {
      key: "2",
      label: "About Subscription",
      children: (
        <AboutSubscription
          isSubscribed={isSubscribed}
          isExpired={isExpired}
          advisorId={id}
        />
      ),
    },
    {
      key: "3",
      label: "Recent Trades",
      children: <RecentTrades advisorId={id} />,
    },
  ];

  return (
    <div className="p-4 lg:p-6 flex flex-col gap-4 lg:gap-6  lg:mx-6 lg:my-6">
      <div className="bg-white rounded-lg p-4 lg:p-6 shadow-[0_2px_8px_rgba(0,0,0,0.1)]">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-4 lg:gap-6">
          <div className="flex items-start gap-3 lg:gap-4 flex-1 w-full">
            <div
              className="flex items-center justify-center w-10 h-10 lg:w-12 lg:h-12 rounded-lg border border-[#D9D9D9] bg-white hover:bg-gray-50 transition-colors"
              onClick={() => {
                navigate("/my-advisors");
              }}
            >
              <img
                src={leftarrow}
                alt="left-arrow"
                className="w-5 h-5 lg:w-6 lg:h-6"
              />
            </div>

            <div className="flex-grow flex flex-col gap-3">
              <div className="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4 flex-wrap">
                <span className="text-xl lg:text-2xl font-bold font-inter text-[#454545]">
                  {advisor?.firstName} {advisor?.lastName}
                </span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-auto">
            <SubscriptionModal
              text={`Subscribe`}
              classname={`text-base w-full lg:w-auto px-6 py-2.5 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors`}
              advisorId={id}
            />
          </div>
        </div>

        <div className="border-t border-gray-200 my-4 lg:my-6" />

        <div className="flex flex-wrap gap-6 lg:gap-8">
          {Object.entries(advisorStats).map(([stat, value]) => (
            <div key={stat} className="flex gap-2 items-center">
              <img
                src={greyCircle}
                width={8}
                height={8}
                alt="bullet"
                className="opacity-60"
              />
              <p className="text-sm lg:text-base">
                <span className="font-normal text-[#7F7F7F] font-roboto">
                  {stat}:
                </span>{" "}
                <span className="font-semibold text-[#454545] font-roboto">
                  {value}
                </span>
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-lg  shadow-[0_2px_8px_rgba(0,0,0,0.1)] p-4 lg:p-6">
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
      </div>
    </div>
  );
};

export default AdvisorProfile;
